import { IdIdentifier, TimeIdentifiers } from '../common/identifiers';
import { CouponItem } from '../coupon/coupon';

export type UserCoupon = IdIdentifier &
  TimeIdentifiers & {
    userId: string;
    couponId: string;
    used: boolean;
    expirationDate: Date;
    name: string;
    items: CouponItem[];
    allowWithCredits?: boolean;
    metadata?: UserCouponMetadata;
  };

export enum UserCouponStatus {
  Valid = 'valid',
  Expired = 'expired',
  UsedOut = 'used-out',
  AlreadyOwn = 'already-own',
  Other = 'other',
}

export type CouponMetrics = {
  activeCount: number;
  usedCount: number;
  totalSaved: number;
};

export type AddCouponByCodeResponse = {
  coupon: UserCoupon | null;
  status: UserCouponStatus;
  affiliationDiscountApplied?: boolean;
  commissionOnlyApplied?: boolean;
};

export type UserCouponMetadata = {
  withdrawalSocialMediaPromotion?: boolean;
};
